import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import Footer from '../components/footer';
import FormCreaRimborsoCompany from "../components/form_crea_rimborso_company";
import FormCreaRimborsoKmCompany from '../components/form_crea_rimborso_km_company';
import { createRimborsoSpese, listaRichiesteRimborsoSpeseCompany, processRichiestaRimborso, deleteRichiestaRimborso } from '../services/api_cost_refunds';
import Swal from 'sweetalert2';
import Fetching from "../components/fetching";
import Empty from '../components/empty';
import moment from 'moment';
import XCircleIcon from '@heroicons/react/24/outline/esm/XCircleIcon';
import CheckCircleIcon from '@heroicons/react/24/outline/esm/CheckCircleIcon';
import { Link } from 'wouter';
import { PencilSquareIcon, TrashIcon, ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import FormEditRimborsoCompany from '../components/form_edit_rimborso_company';
import CalendarMonthSelect from '../components/calendar_month_select';
import FormEditRimborsoKmCompany from '../components/form_edit_rimborso_km_company';
import { exportCostRefunds } from '../services/api_extractions';
import MonthYearListbox from '../components/month_year_listbox';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import RuleFolderOutlinedIcon from '@mui/icons-material/RuleFolderOutlined';
import PopoverComponentCustom from '../components/popover_component';


const RimborsoSpeseCompany = () => {
  const { loading, token, profile } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [records, setRecords] = useState([]);
  const [recordToReview, setRecordToReview] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showFormRimborsoKm, setShowFormRimborsoKm] = useState(false);
  const [error, setError] = useState(null);
  const [visibleRecordId, setVisibleRecordId] = useState(null);
  const [currentPageNull, setCurrentPageNull] = useState(1);
  const [totalPagesNull, setTotalPagesNull] = useState(1);
  const [currentPageNoNull, setCurrentPageNoNull] = useState(1);
  const [totalPagesNoNull, setTotalPagesNoNull] = useState(1);
  const [editRecordId, setEditRecordId] = useState(null);
  const [hideButtonDetails, setHideButtonDetails] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null); 
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [calendarRequestNullVisible, setCalendarRequestNullVisible] = useState(false);
  const [selectedMonthNull, setSelectedMonthNull] = useState(new Date());
  const [selectedMonthNoNull, setSelectedMonthNoNull] = useState(new Date());
  const [showButtonKm, setShowButtonKm] = useState(true);
  const [showButtonSpese, setShowButtonSpese] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(null);

  const isProfileComplete = profile.has_complete_profile;

// Fetch records for 'null' status based on selected month and year
useEffect(() => {
  if (selectedMonthNull) {
    fetchRecords(
      'null', 
      currentPageNull, 
      setRecordToReview, 
      setTotalPagesNull, 
      selectedMonthNull.getMonth() + 1, 
      selectedMonthNull.getFullYear()
    );
  }
}, [currentPageNull, selectedMonthNull]);

// Fetch records for 'no_null' status based on selected month and year
useEffect(() => {
  if (selectedMonthNoNull) {
    fetchRecords(
      'no_null', 
      currentPageNoNull, 
      setRecords, 
      setTotalPagesNoNull, 
      selectedMonthNoNull.getMonth() + 1, 
      selectedMonthNoNull.getFullYear()
    );
  }
}, [currentPageNoNull, selectedMonthNoNull]);



  const fetchRecords = async (status, page, setData, setTotalPages, month, year) => {
    setIsLoading(true);
    try {
      const response = await listaRichiesteRimborsoSpeseCompany(token, page, status, 10, month, year, 'cost_refunds');
      setData(response.results || []);
      setTotalPages(Math.ceil(response.count / 10));

    } catch (error) {
      console.error(error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNextPageNull = () => {
    if (currentPageNull < totalPagesNull) {
      setCurrentPageNull(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPageNull = () => {
    if (currentPageNull > 1) {
      setCurrentPageNull(prevPage => prevPage - 1);
    }
  };

  const handleNextPageNoNull = () => {
    if (currentPageNoNull < totalPagesNoNull) {
      setCurrentPageNoNull(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPageNoNull = () => {
    if (currentPageNoNull > 1) {
      setCurrentPageNoNull(prevPage => prevPage - 1);
    }
  };

  const submitForm = async (formData) => {
    try {
        const response = await createRimborsoSpese(token, formData);

        setRecords(prevRecords => [...prevRecords, response]);
        setRecordToReview(prevRecordsToReview => {
            if (response.status === null) {
                return [...prevRecordsToReview, response];
            }
            return prevRecordsToReview;
        });

        await Swal.fire({
            title: 'Salvato!',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
        });


        await handleAfterSubmit();
    } catch (error) {
        setError(error);
        fetchRecords();  
    }
  };

  const handleAfterSubmit = async () => {
    try {
      const month = (selectedMonthNoNull ? selectedMonthNoNull.getMonth() + 1 : new Date().getMonth() + 1);
      const year = (selectedMonthNoNull ? selectedMonthNoNull.getFullYear() : new Date().getFullYear());
  
      await fetchRecords(
        'no_null',
        1,
        setRecords,
        setTotalPagesNoNull,
        month,
        year
      );
  
      setShowForm(false);
      setShowFormRimborsoKm(false);
      setShowButtonSpese(true);
      setShowButtonKm(true);
    } catch (error) {
      console.error("Errore durante il recupero dei dati:", error);
      await Swal.fire({
        title: 'Errore',
        text: 'Si è verificato un errore durante il salvataggio.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  const updateRecordStatus = async (currentRecord, status) => {
    try {
      await processRichiestaRimborso(token, currentRecord.id, status);
  
      setRecords(prevRecords => [...prevRecords, { ...currentRecord, status }]);
  
      setRecordToReview(prevRecordsToReview =>
        prevRecordsToReview.filter(record => record.id !== currentRecord.id)
      );
  
      await Swal.fire({
        title: 'Salvato!',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } catch (error) {
      setError(error);
      fetchRecords();
    }
  };
  

  const handleDelete = async (record, id) => {
    const result = await Swal.fire({
      title: 'Sei sicuro?',
      text: "Stai eliminando la richiesta di un rimborso e l'operazione non è reversibile. Confermi l'eliminazione?",
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sì, confermo',
      cancelButtonText: 'No, annulla',
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await deleteRichiestaRimborso(token, id);

        await Swal.fire({
          title: 'Eliminato!',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        setRecords((prevRecords) =>
          prevRecords.filter((record) => record.id !== id)
        );
        setRecordToReview((prevRecordsToReview) =>
          prevRecordsToReview.filter((record) => record.id !== id)
        );

      } catch (error) {
        Swal.fire('Errore!', 'Si è verificato un errore durante l\'eliminazione.', 'error');
      }
    }
  };

  const toggleForm = () => {
    if (editRecordId) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Completa l\'operazione in corso prima di creare un nuovo rimborso.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowForm(!showForm);
      setShowButtonKm(!showButtonKm);
    }
  };

  const toggleFormRimborsoKm = () => {
    if (editRecordId) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Completa l\'operazione in corso prima di creare un nuovo rimborso.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowFormRimborsoKm(!showFormRimborsoKm);
      setShowButtonSpese(!showButtonSpese);
    }
  };

  const toggleDetails = (recordId) => {
    setVisibleRecordId((prevId) => (prevId === recordId ? null : recordId));
  };

  const handleEdit = (record) => {
    if (showForm || showFormRimborsoKm) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Chiudi il form di creazione prima di modificare una richiesta.',
        confirmButtonText: 'OK'
      });
    } else {
      setCurrentRecord(record);
      setIsEditing(true);
      setEditRecordId(record.id);
      setVisibleRecordId(null);
      setHideButtonDetails(true);
    }
  };


  const handleAfterSubmitEditRecord = async (updatedRecord) => {
    setRecordToReview((prevRecords) =>
      prevRecords.map((record) =>
        record.id === updatedRecord.id ? updatedRecord : record
      )
    );
    
    await fetchRecords(
      'null', 
      currentPageNull, 
      setRecordToReview, 
      setTotalPagesNull, 
      selectedMonthNull.getMonth() + 1, 
      selectedMonthNull.getFullYear()
    );
  
    setEditRecordId(null);
    setHideButtonDetails(false);
  };

  const handleAfterSubmitEditRecordProcessed = async (updatedRecord) => {
    setRecords((prevRecords) =>
      prevRecords.map((record) =>
        record.id === updatedRecord.id ? updatedRecord : record
      )
    );
  
    await fetchRecords(
      'no_null', 
      currentPageNoNull, 
      setRecords, 
      setTotalPagesNoNull, 
      selectedMonthNoNull.getMonth() + 1, 
      selectedMonthNoNull.getFullYear()
    );
  
    setEditRecordId(null);
    setHideButtonDetails(false);
  };
  
  const handleCancelEdit = () => {
    setIsEditing(false);
    setCurrentRecord(null);
    setEditRecordId(null);
    setHideButtonDetails(false);
  };

  const handleEditStatus = async (record) => {
    const statusMapping = {
      'approved': 'approvata',
      'rejected': 'rifiutata'
    };
  
    const formattedDate = moment(record.reviewed_on).format('DD/MM/YYYY');
  
    const currentStatus = statusMapping[record.status] || record.status;
    const newStatus = record.status === 'approved' ? 'rejected' : 'approved';
    const newStatusLabel = statusMapping[newStatus] || newStatus;
    
    let reviewedByText = '';

    if (record.reviewed_by) {
      const hasName = record.reviewed_by.last_name && record.reviewed_by.first_name;
      if (hasName) {
        reviewedByText = ` da ${record.reviewed_by.last_name} ${record.reviewed_by.first_name}`;
      } else if (record.reviewed_by.cf) {
        reviewedByText = ` da CF: ${record.reviewed_by.cf}`;
      }
    }
  
    const message = `La richiesta è stata ${currentStatus} in data ${formattedDate}${reviewedByText}.<br>Confermi di volerla ${newStatusLabel === 'approvata' ? 'approvare' : 'rifiutare'}?`;
  
    const result = await Swal.fire({
      title: 'Modifica Status Richiesta',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Conferma e modifica`,
      cancelButtonText: 'Annulla'
    });
  
    if (result.isConfirmed) {
      await updateStatusProcessedRequest(record, newStatus);
    }
  };

  const updateStatusProcessedRequest = async (currentRecord, status) => {
    try {
      await processRichiestaRimborso(token, currentRecord.id, status);
  
      setRecords(prevRecords =>
        prevRecords.map(record =>
          record.id === currentRecord.id ? { ...record, status } : record
        )
      );

      await Swal.fire({
        title: 'Salvato!',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } catch (error) {
      setError(error);
      fetchRecords();
    }
  };

  const handlePreviousMonthNoNull = () => {
    setSelectedMonthNoNull(new Date(selectedMonthNoNull.getFullYear(), selectedMonthNoNull.getMonth() - 1, 1));
  };
  
  const handleNextMonthNoNull = () => {
    setSelectedMonthNoNull(new Date(selectedMonthNoNull.getFullYear(), selectedMonthNoNull.getMonth() + 1, 1));
  };
  
  const handleSelectClick = () => {
    setCalendarVisible(!calendarVisible);
  };

  const handlePreviousMonthNull = () => {
    setSelectedMonthNull(new Date(selectedMonthNull.getFullYear(), selectedMonthNull.getMonth() - 1, 1));
  };
  
  const handleNextMonthNull = () => {
    setSelectedMonthNull(new Date(selectedMonthNull.getFullYear(), selectedMonthNull.getMonth() + 1, 1));
  };

  const handleSelectClickRequestNull = () => {
    setCalendarRequestNullVisible(!calendarRequestNullVisible);
  };


  const handleExportCostRefunds = async () => {
    setIsLoading(true);
    setIsError(false);

    const month = selectedMonth.getMonth() + 1;
    const year = selectedMonth.getFullYear();
    const businessName = profile.company.name;

    console.log('mese e anno selezionati', month, year);
    

    Swal.fire({
        title: 'Download in corso...',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    try {
        const result = await exportCostRefunds(token, month, year, businessName);

        if (!result.success) {
            Swal.fire({
                icon: 'info',
                title: 'Nessun dato trovato!',
                text: result.error,
                showConfirmButton: true,
            });
        } else {
            Swal.fire({
                icon: 'success',
                title: 'Esportazione completata!',
                showConfirmButton: true,
            });
        }
    } catch (error) {
        setIsError(true);

        Swal.fire({
            icon: 'error',
            title: 'Errore durante l\'esportazione!',
            text: error.message,
            showConfirmButton: true,
        });
    } finally {
        setIsLoading(false);
    }
  };

  

  if (isError) return <div>Error loading data</div>;
  
  return <div>
    <div className="min-h-full">
      <PopoverComponentCustom title='Rimborsi Spese' />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}

      <section>
        <div className="container-fluid w-full px-4 pt-4">

          <div className="grid grid-cols-6 gap-4 mt-2 items-center px-10">
            <div className='col-span-6 flex items-center'>
              <h3 className="text-base font-semibold leading-6 text-gray-900">Aggiungi Nuovo Rimborso</h3>
              {showButtonSpese && (
                <button
                  onClick={toggleForm}
                  className={`ml-4 text-sm p-2 rounded-md font-semibold w-56 whitespace-nowrap ${showForm ? 'bg-gray-200 text-gray-800 hover:bg-gray-400 hover:text-white' : 'bg-indigo-600 text-white hover:bg-indigo-500'}`}
                >
                  {showForm ? 'Annulla' : 'Crea Rimborso Spese'}
                </button>
              )}
              {showButtonKm && (
                <button
                onClick={toggleFormRimborsoKm}
                className={`ml-4 text-sm p-2 rounded-md font-semibold w-56 whitespace-nowrap ${showFormRimborsoKm ? 'bg-gray-200 text-gray-800 hover:bg-gray-400 hover:text-white' : 'bg-indigo-600 text-white hover:bg-indigo-500'}`}
                >
                  {showFormRimborsoKm ? 'Annulla' : 'Crea Rimborso Chilometrico'}
                </button>
              )}
              
            </div>
          </div>

          <div className=" mx-auto px-6 py-2 bg-white rounded-md">
            {showForm && (
              <>
                <h1 className='text-center text-xl font-semibold text-indigo-800 bg-indigo-100 rounded-md'>Nuovo Rimborso Spese</h1>
                <FormCreaRimborsoCompany submitForm={submitForm} afterSubmit={handleAfterSubmit} />
              </>
            )}
            {showFormRimborsoKm && (
              <>
                <h1 className='text-center text-xl font-semibold text-indigo-800 bg-indigo-100 rounded-md'>Nuovo Rimborso Chilometrico</h1>
                <FormCreaRimborsoKmCompany submitForm={submitForm} afterSubmit={handleAfterSubmit} />
              </>
            )}
          </div>
        </div>
      </section>
            
      <section>
        <div className="container-fluid w-full px-4 pt-4">
          <div className="grid grid-cols-6 gap-4 mt-2 items-center px-10">
            <div className='col-span-6 flex items-center'>
              <h3 className="text-base font-semibold leading-6 text-gray-900 me-4">Download Rimborsi Spese</h3>
              <MonthYearListbox selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} />
              <button onClick={handleExportCostRefunds} disabled={isLoading} className='ml-4 text-sm p-2 rounded-md font-semibold whitespace-nowrap bg-indigo-600 text-white hover:bg-indigo-500'>
                  {isLoading ? 'Caricamento...' : 'Scarica'}
              </button>
              {isError && <p>Si è verificato un errore. Riprova.</p>}
            </div>
          </div>
        </div>
      </section>
      
      {/* RICHIESTE DA APPROVARE */}
      <section>
        {(isLoading) && <Fetching />}
      </section>
      
      
      <div className="px-4 sm:px-6 lg:px-8 mt-8">
        <div className="max-h-[90vh] overflow-y-auto shadow-lg overflow-x-auto ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">

          <div className='grid grid-cols-1 w-full py-4 sticky top-0 bg-white z-20'>
            <div
              style={{ flex: '1 1 auto', width: 'auto' }}
              className="pb-5 px-4 border-l border-r border-gray-200 text-center w-24 text-xs font-semibold text-gray-600 uppercase align-middle"
            >
              <div className='text-left pb-8 text-xl text-indigo-800'>
                <HourglassTopIcon className='inline-block flex w-4 h-4 me-2' />
                Richieste da approvare
              </div>
              <div className='grid  md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3'>
                  <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                      <button
                          className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                          onClick={handlePreviousMonthNull} 
                      >
                          <ChevronLeftIcon className="w-5 h-5 cursor-pointer" />
                      </button>
                  </div>
                  <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Mese</div>
                  <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
                      <button
                          className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                          onClick={handlePreviousMonthNull}
                      >
                          <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                      </button>
                  </div>
                  <div
                      onClick={handleSelectClickRequestNull}
                      style={{ cursor: 'pointer' }}
                      className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between'
                  >
                      <div>
                          {selectedMonthNull.toLocaleDateString('it-IT', { month: 'long' })}, {selectedMonthNull.getFullYear()}
                      </div>
                      {!calendarRequestNullVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
                  </div>
                  <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
                      <button
                          className='text-gray-700 font-semibold px-1 hover:bg-gray-100 flex items-start'
                          onClick={handleNextMonthNull}
                      >
                          <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                      </button>
                  </div>
              </div>
              {calendarRequestNullVisible && 
                <CalendarMonthSelect
                  selectedMonth={selectedMonthNull} 
                  onMonthSelect={setSelectedMonthNull} 
                  onCloseCalendar={handleSelectClickRequestNull}
                />
              }
            </div>      
          </div>

          <table className="min-w-full divide-y divide-gray-300">
            <thead className='sticky top-0 bg-white z-10 border-b border-gray-200'>
              <tr>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                  Dipendente
                </th>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                  Oggetto
                </th>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                  Importo
                </th>
                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                  Azioni
                </th>
                <th scope="col" className="text-right text-sm font-semibold text-gray-900">
                  
                </th>
              </tr>
            </thead>
            <tbody>
              {(isLoading) && (
                <tr>
                  <td colSpan={6} className="text-center">
                    <Fetching />
                  </td>
                </tr>
              )}

              {!isError && recordToReview.length > 0 ? (
                recordToReview.map((record) => (
                  <React.Fragment key={record.id}>
                    <tr>
                      <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                        <Link
                          to={`/dipendenti/${record.employee.cf}`}
                          className="hover:text-indigo-600 cursor-pointer font-medium text-gray-900"
                        >
                          {record.employee.first_name
                            ? `${record.employee.last_name} ${record.employee.first_name}`
                            : record.employee.cf}
                        </Link>
                      </td>
                      <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                        <div className="font-medium text-gray-900">
                          {record.title.length > 15 ? record.title.substring(0, 15) + "..." : record.title}
                        </div>
                      </td>
                      <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                        {record.title == 'Rimborso Chilometrico' ? (
                          <div className="font-medium text-gray-900">KM {record.amount}</div>
                        ) : (
                          <div className="font-medium text-gray-900">€ {record.amount}</div>
                        )}
                      </td>
                      <td className="border-t border-b border-gray-200 text-center">
                        <div className="flex justify-center items-center space-x-2">
                          <button
                            className='text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md'
                            onClick={() => updateRecordStatus(record, 'approved')}
                          >
                            Approva
                          </button>
                          <button
                            className='text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md'
                            onClick={() => updateRecordStatus(record, 'rejected')}
                          >
                            Rifiuta
                          </button>
                          <button
                            className='text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md flex items-center justify-center'
                            title='Modifica'
                            onClick={() => handleEdit(record)}
                        
                          >
                            <PencilSquareIcon className='h-5 w-5' />
                          </button>
                          <button
                            className='text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md flex items-center justify-center me-3'
                            onClick={() => handleDelete(record, record.id)}
                            title='Elimina'
                        
                          >
                            <TrashIcon className='h-5 w-5' />
                          </button>
                        </div>
                      </td>
                      <td className="text-sm border-b text-end pe-4">
                        {!hideButtonDetails && (
                          <button
                            onClick={() => toggleDetails(record.id)}
                            className="text-sm font-semibold bg-gray-200 hover:bg-gray-300 w-28 p-1 text-gray-600 rounded-md"
                          >
                            {visibleRecordId === record.id ? 'Chiudi' : 'Più dettagli'}
                          </button>
                        )}
                      </td>
                    </tr>

                    {visibleRecordId === record.id && (
                      <>
                        {/* Oggetto */}
                        <tr key={`${record.id}-title`} className="bg-indigo-50">
                          <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                            <span className="font-medium text-gray-900">Oggetto </span>
                            {record.title}
                          </td>
                        </tr>

                        {/* DATA */}
                        <tr key={`${record.id}-date`} className="bg-indigo-50">
                          <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                            <span className="font-medium text-gray-900">Data </span>
                            {record.date ? (
                            <time dateTime={record.date}>
                              {moment(record.date).format('DD/MM/YYYY')}
                            </time>
                          ) : (
                            ''
                          )}
                          </td>
                        </tr>

                        {/* Importo / NUMERO KM */}
                        <tr key={`${record.id}-amount`} className="bg-indigo-50">
                          <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                            {record.title === 'Rimborso Chilometrico' ? (
                              <>
                                <span className="font-medium text-gray-900">KM </span>
                                {record.amount}
                              </>
                            ) : (
                              <>
                                <span className="font-medium text-gray-900">Importo </span>
                                € {record.amount}
                              </>
                            )}
                          </td>
                        </tr>

                        {/* Description */}
                        <tr key={`${record.id}-description`} className="bg-indigo-50">
                          <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                            <span className="font-medium text-gray-900">Descrizione </span>
                            <div
                              className="description-content"
                              dangerouslySetInnerHTML={{ __html: record.description || '' }}
                            />
                          </td>
                        </tr>

                        {/* Files */}
                        <tr key={`${record.id}-file`} className="border-b border-gray-200 bg-indigo-50">
                          <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                            <span className="font-medium text-gray-900">Allegati </span>
                            {record.file && <a href={record.file} className="text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 ml-3 text-white rounded-md" target="_blank">Visualizza</a>}
                          </td>
                        </tr>
                      </>
                    )}

                    {/* FORM MODIFICA RICHIESTA CON STATUS NULL */}
                    {editRecordId === record.id && (
                      <tr>
                        <td colSpan="10" className="py-4">
                          {record.title === 'Rimborso Chilometrico' ? (
                            <FormEditRimborsoKmCompany 
                              submitForm={submitForm} 
                              afterSubmitEditRecord={handleAfterSubmitEditRecord} 
                              recordToEdit={record} 
                              onCancelEdit={handleCancelEdit} 
                            />
                          ) : (
                            <FormEditRimborsoCompany 
                              submitForm={submitForm} 
                              afterSubmitEditRecord={handleAfterSubmitEditRecord} 
                              recordToEdit={record} 
                              onCancelEdit={handleCancelEdit} 
                            />
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
              ))
              ) : (
                !isError && recordToReview.length === 0 && !isLoading && (
                  <tr>
                    <td colSpan="10" className='container-fluid w-full px-4 pt-4'>
                      <Empty />
                    </td>
                  </tr>
                )
              )}

              {/* Paginazione */}
              <tr className='bg-gray-50 sticky bottom-0 z-10'>
                <td colSpan="10" className="py-4">
                  <div className="flex items-center justify-between">
                    <button
                      onClick={handlePreviousPageNull}
                      disabled={currentPageNull === 1}
                      className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ml-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                        currentPageNull === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                      }`}
                    >
                      Pagina precedente
                    </button>

                    <div className="text-sm font-semibold text-gray-800 px-2">
                      Pagina {currentPageNull} di {totalPagesNull}
                    </div>

                    <button
                      onClick={handleNextPageNull}
                      disabled={currentPageNull === totalPagesNull}
                      className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 mr-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                        currentPageNull === totalPagesNull ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                      }`}
                    >
                      Pagina successiva
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

        
      {/* RIEPILOGO */}     
        <div className="px-4 sm:px-6 lg:px-8 mt-16">
          <div className="max-h-[90vh] shadow-lg overflow-y-auto overflow-x-auto ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">

            <div className='grid grid-cols-1 w-full py-4 sticky top-0 bg-white z-20'>
              <div
                style={{ flex: '1 1 auto', width: 'auto' }}
                className="pb-5 pt-2 px-4 border-l border-r border-gray-200 text-center w-24 text-xs font-semibold text-gray-600 uppercase align-middle"
              >
                <div className='text-left pb-8 text-xl text-indigo-800'>
                  <RuleFolderOutlinedIcon className='inline-block flex me-2' style={{ width: '35px', height: '35px' }} />
                  Riepilogo richieste gestite
                </div>
                <div className='grid  md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3'>
                    <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                        <button
                            className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                            onClick={handlePreviousMonthNoNull} 
                        >
                            <ChevronLeftIcon className="w-5 h-5 cursor-pointer" />
                        </button>
                    </div>
                    <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Mese</div>
                    <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
                        <button
                            className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                            onClick={handleNextMonthNoNull}
                        >
                            <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                        </button>
                    </div>
                    <div
                        onClick={handleSelectClick}
                        style={{ cursor: 'pointer' }}
                        className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between'
                    >
                        <div>
                            {selectedMonthNoNull.toLocaleDateString('it-IT', { month: 'long' })}, {selectedMonthNoNull.getFullYear()}
                        </div>
                        {!calendarVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
                    </div>
                    <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
                        <button
                            className='text-gray-700 font-semibold px-1 hover:bg-gray-100 flex items-start'
                            onClick={handleNextMonthNoNull}
                        >
                            <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                        </button>
                    </div>
                </div>
                {calendarVisible && 
                  <CalendarMonthSelect
                    selectedMonth={selectedMonthNoNull} 
                    onMonthSelect={setSelectedMonthNoNull} 
                    onCloseCalendar={handleSelectClick}
                  />
                }
              </div>      
            </div>
         
            <table className="min-w-full divide-y divide-gray-300">
              <thead className='border-b border-gray-200 bg-gray-50'>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">
                    Dipendente
                  </th>
                  <th scope="col" className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">
                    Oggetto
                  </th>
                  <th scope="col" className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">
                    Importo
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                    Status
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                    Modifica Status
                  </th>
                  <th scope="col" className="text-right text-sm font-semibold text-gray-900">
                    
                  </th>
                </tr>
              </thead>
              <tbody>
                {(isLoading) && (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <Fetching />
                    </td>
                  </tr>
                )}
                {!isError && records.length > 0 ? (
                  records.sort((a, b) => b.id - a.id).map((record) => (
                    <React.Fragment key={record.id}>
                      <tr>
                        <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                          <Link
                            to={`/dipendenti/${record.employee.cf}`}
                            className="hover:text-indigo-600 cursor-pointer font-medium text-gray-900"
                          >
                            {record.employee.first_name
                              ? `${record.employee.last_name} ${record.employee.first_name}`
                              : record.employee.cf}
                          </Link>
                        </td>
                        <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                          <div className="font-medium text-gray-900">
                            {record.title.length > 15 ? record.title.substring(0, 15) + "..." : record.title}
                          </div>
                        </td>
                        {/* <td className="relative py-4 pl-4 pr-3 text-sm border-b">
                          {record.date ? (
                            <time dateTime={record.date}>
                              {moment(record.date).format('DD/MM/YYYY')}
                            </time>
                          ) : (
                            ''
                          )}
                        </td> */}
                        <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                          {record.title === 'Rimborso Chilometrico' ? (
                              <>
                                KM {record.amount}
                              </>
                            ) : (
                              <>
                                € {record.amount}
                              </>
                            )}
                        </td>
                        <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b text-center">
                          {record.status === 'approved' ? (
                            <CheckCircleIcon className="w-5 h-5 text-teal-500 mx-auto" />
                          ) : (
                            <XCircleIcon className="w-5 h-5 text-red-500 mx-auto" />
                          )}
                        </td>
                        <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b text-center">
                          <button
                            onClick={() => handleEditStatus(record)}
                            className="text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md"
                          >
                            Modifica Status
                          </button>
                        </td>
                        <td className="relative text-sm border-b text-end pe-4">
                        {!hideButtonDetails && (
                          <button
                            onClick={() => toggleDetails(record.id)}
                            className="text-sm font-semibold bg-gray-200 hover:bg-gray-300 w-28 p-1 text-gray-600 rounded-md"
                          >
                            {visibleRecordId === record.id ? 'Chiudi' : 'Più dettagli'}
                          </button>
                        )}
                        </td>
                      </tr>

                      {visibleRecordId === record.id && (
                        <>
                          <tr className="bg-indigo-50">
                            <td colSpan="10" className="pt-3 px-4 text-gray-700 text-sm text-right pb-0">
                              <button className='px-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md me-3' onClick={() => handleEdit(record)}> 
                                <PencilSquareIcon className='h-5 w-5 inline-block' /> Modifica Richiesta
                              </button>
                              <button className='px-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 text-white rounded-md'
                                onClick={() => handleDelete(record, record.id)}
                              >
                                <TrashIcon className='h-5 w-5 inline-block' /> Elimina
                              </button>
                            </td>
                          </tr>

                          {/* Oggetto */}
                          <tr key={`${record.id}-title`} className="bg-indigo-50">
                            <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                              <span className="font-medium text-gray-900">Oggetto </span>
                              {record.title}
                            </td>
                          </tr>

                          {/* DATA */}
                          <tr key={`${record.id}-date`} className="bg-indigo-50">
                            <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                              <span className="font-medium text-gray-900">Data </span>
                              {record.date ? (
                              <time dateTime={record.date}>
                                {moment(record.date).format('DD/MM/YYYY')}
                              </time>
                            ) : (
                              ''
                            )}
                            </td>
                          </tr>

                          {/* Importo */}
                          <tr key={`${record.id}-amount`} className="bg-indigo-50">
                            <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                              {record.title === 'Rimborso Chilometrico' ? (
                                <>
                                  <span className="font-medium text-gray-900">KM </span>
                                  {record.amount}
                                </>
                              ) : (
                                <>
                                  <span className="font-medium text-gray-900">Importo </span>
                                  € {record.amount}
                                </>
                              )}
                            </td>
                          </tr>

                          {/* Description */}
                          <tr key={`${record.id}-description`} className="bg-indigo-50">
                            <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                              <span className="font-medium text-gray-900">Descrizione </span>
                              <div
                                className="description-content"
                                dangerouslySetInnerHTML={{ __html: record.description || '' }}
                              />
                            </td>
                          </tr>

                          {/* Files */}
                          <tr key={`${record.id}-file`} className="bg-indigo-50">
                            <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                              <span className="font-medium text-gray-900">Allegati </span>
                              {record.file && <a href={record.file} className="text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 p-1 ml-3 text-white rounded-md" target="_blank">Visualizza</a>}
                            </td>
                          </tr>

                          {/* Reviewed On */}
                          <tr key={`${record.id}-reviewed_on`} className="bg-indigo-50">
                            <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                              <span className="font-medium text-gray-900">Richiesta elaborata il </span>
                              <time dateTime={record.reviewed_on}>
                                {record.reviewed_on
                                  ? moment(record.reviewed_on).format('DD/MM/YYYY, HH:mm')
                                  : ''}
                              </time>
                              {record.reviewed_by && (
                                <>
                                  <span className="font-medium text-gray-900"> da </span>
                                  <span>
                                    {record.reviewed_by.last_name && record.reviewed_by.first_name ? (
                                      `${record.reviewed_by.last_name} ${record.reviewed_by.first_name}`
                                    ) : (
                                      record.reviewed_by.cf
                                    )}
                                  </span>
                                </>
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                      {/* FORM MODIFICA RICHIESTA CON STATUS NON NULL */}
                      {editRecordId === record.id && (
                        <tr>
                          <td colSpan="10" className="py-4">
                            {record.title === 'Rimborso Chilometrico' ? (
                              <FormEditRimborsoKmCompany 
                                submitForm={submitForm} 
                                afterSubmitEditRecord={handleAfterSubmitEditRecordProcessed} 
                                recordToEdit={record} 
                                onCancelEdit={handleCancelEdit} 
                              />
                            ) : (
                              <FormEditRimborsoCompany 
                                submitForm={submitForm} 
                                afterSubmitEditRecord={handleAfterSubmitEditRecordProcessed} 
                                recordToEdit={record} 
                                onCancelEdit={handleCancelEdit} 
                              />
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  !isError && records.length === 0 && !isLoading && (
                    <tr>
                      <td colSpan="10" className='container-fluid w-full px-4 pt-4'>
                        <Empty />
                      </td>
                    </tr>
                  )
                )}

                {/* Paginazione */}
                <tr className='bg-gray-50 sticky bottom-0 z-10'>
                  <td colSpan="10" className="py-4">
                    <div className="flex items-center justify-between">
                      <button
                        onClick={handlePreviousPageNoNull}
                        disabled={currentPageNoNull === 1}
                        className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ml-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                          currentPageNoNull === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                        }`}
                      >
                        Pagina precedente
                      </button>

                      <div className="text-sm font-semibold text-gray-800">
                        Pagina {currentPageNoNull} di {totalPagesNoNull}
                      </div>

                      <button
                        onClick={handleNextPageNoNull}
                        disabled={currentPageNoNull === totalPagesNoNull}
                        className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 mr-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                          currentPageNoNull === totalPagesNoNull ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                        }`}
                      >
                        Pagina successiva
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      
      <div className='pt-8'>
        <Footer />
      </div>
      
    </div>
  </div>;
};

export default RimborsoSpeseCompany
